module.exports = __webpack_public_path__ + "static/media/concrete-wall-2.44e11fda.png";